import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { default as SM } from 'scrollmonitor';
import { TweenLite } from 'gsap';
import Gallery from './Gallery';
import ImgLoader from 'components/common/ImgLoader';
import get from 'lodash/get';

class CuratedItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			holding: true
		}
		this.el = React.createRef();
		this.inner = React.createRef();
		this.galleryWrapper = React.createRef();
		this.info = React.createRef();

		this.innerTween = null;
		this.galleryWrapperTween = null;
		this.infoTween = null;

		const items = get( this.props, 'associatedProjects', false );
		if ( items ) {
			// Filter away items WITHOUT cover image
			const filtered = items.filter( item => (item.coverImage || item.coverImageAlt) );
			if ( filtered.length > 0 ) this.items = filtered;
		}
	}
	componentDidMount() {
		if ( !this.items ) return;
		this.sm = SM.create( this.el.current );
		this.sm.enterViewport( this.onEnter );
		this.sm.exitViewport( this.onExit );
	}
	unhold = () => {
		this.setState({'holding': false});
	}
	onEnter = () => {
		// enter from below. i.e. scrolling DOWN
		if ( this.sm.isBelowViewport ) {
			const fromY = SM.documentHeight * 0.15; 
			this.galleryWrapperTween = TweenLite.from( this.galleryWrapper.current, 0.4, { opacity: 0, y: fromY } )
			this.infoTween = TweenLite.from( this.info.current, 0.2, { delay: 0.2, opacity: 0 } );
		}
	}
	onExit = () => {
		this.killTweens();
	}
	killTweens = () => {
		[this.innerTween, this.galleryWrapperTween, this.infoTween].forEach( tween => {
			if ( tween ) { tween.totalProgress(1).kill(); tween = null; }
		} )
	}
	componentWillUnmount() {
		if ( this.sm ) this.sm.destroy();
		this.killTweens();
	}
	onGalleryMouseEnter = (e) => {
		if ( this.props.onMouseEnter ) this.props.onMouseEnter( this.props.index );
	}
	onGalleryMouseLeave = (e) => {
		if ( this.props.onMouseLeave ) this.props.onMouseLeave( this.props.index );
	}
	render() {
		if ( !this.items ) return null;

		let gallery = this.items.slice(0, 5).map( (item) => {
			const cover = item.coverImageAlt || item.coverImage || {};
			const alt = [item.title, item.row2].filter(Boolean).join(" ");
			const hex = item.prominentColorOfCoverImage;
			return {
				src: cover.src,
				width: cover.width,
				height: cover.height,
				alt: alt,
				hex: hex,
			}
		} )
		const count = this.items.length;
		const path = '/curated/' + this.props.slug;
		const useGallery = (!this.state.holding && this.props.rich_data);
		
		return (
			<div ref={this.el} className="CuratedItem">
				<div ref={this.inner} className="CuratedItem-inner">
					<Link to={path}>
						<div ref={this.galleryWrapper} className="GalleryWrapper" onMouseEnter={this.onGalleryMouseEnter} onMouseLeave={this.onGalleryMouseLeave}>
								{ !useGallery && (gallery.length > 0) &&
									<ImgLoader {...gallery[0]} 
										wait={true}
										ontransitionend={this.unhold} 
										transitionMode="slide"/> }
								{ useGallery && 
									<Gallery 
										items={ gallery } 
										speed={this.props.speed} /> }
						</div>
						<div className="CuratedItem-info" ref={this.info}><span className="title">#{this.props.title}</span> <span className="count">{count}</span></div>
					</Link>
				</div>
			</div>
		)
	}
}
CuratedItem.propTypes = {
	slug: PropTypes.string, 
	index: PropTypes.number,
	title: PropTypes.string, 
	items: PropTypes.array,
	speed: PropTypes.number,
	onMouseEnter: PropTypes.func,
	onMouseLeave: PropTypes.func
}
const mapStateToProps = (state) => {
	return {
		rich_data: state.status.rich_data,
	}
}
export default connect(mapStateToProps)(CuratedItem);


// WEBPACK FOOTER //
// ./src/components/Pages/Home/CuratedItem.jsx